// import { Outlet } from "react-router-dom";
// import ScrollToTop from "./ScrollToTop";


// const RootLayout = () => {
//   return (
//     <>
//       <ScrollToTop />
//       <Outlet />
//     </>
//   );
// };

// export default RootLayout;





import { useEffect } from "react";
import { Outlet } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setUser } from "@/redux/authSlice";

import Footer from "../Footer";
import Navbar from "./Navbar";
import CookieBanner from "./CookieBanner";
import OfferBanner from "./OfferBanner";

const RootLayout = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    const clearUserOnUnload = () => {
      sessionStorage.removeItem("user");
      dispatch(setUser(null));
    };

    window.addEventListener("beforeunload", clearUserOnUnload);
    return () => window.removeEventListener("beforeunload", clearUserOnUnload);
  }, [dispatch]);

  return (
    <>
      {/* Offer Banner - Shows on first load */}
      <OfferBanner />

      {/* Cookie Banner */}
      <CookieBanner/>

      {/* Main App UI */}
      <Navbar/>
      <main>
        <Outlet />
      </main>
      
    </>
  );
};

export default RootLayout;

